import { Paper, Title } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useState } from 'react';
import MerchantBranchTransactionFilter from '../../components/merchant-transactions/merchant-branch-transactions-filter';
import MerchantTransactionsDetails from '../../components/merchant-transactions/merchant-transactions-details';
import MerchantTransactionsTable from '../../components/merchant-transactions/merchant-transactions-table.component';
import { IPaginationMeta } from '../../type/admin.types';
import {
  AdminTransactionSelectData,
  TransactionFilterForm,
} from '../../type/filter.types';
import {
  BasicTransactionResponseDetails,
  BasicTransactionResponseSummary,
  RetrieveAllTransactionsRequest,
  TransactionStats,
} from '../../type/retrieve-transaction.types';

function MerchantBranchTransactionsPage() {
  const [isLoadBranches, setIsLoadBranches] = useState(true);
  const [paginationData, setPaginationData] = useState<IPaginationMeta>();
  const [data, setData] = useState<BasicTransactionResponseSummary[]>([]);
  const [transactionStats, setTransactionStats] = useState<TransactionStats>();
  const [page, setPage] = useState<number>(1);
  const [transactionDetails, setTransactionDetails] =
    useState<BasicTransactionResponseDetails[]>();
  const [detailsPaginationData, setDetailsPaginationData] =
    useState<IPaginationMeta>();
  const [transactionSummaryRequest, setTransactionSummaryRequest] =
    useState<RetrieveAllTransactionsRequest>();
  const [transactionDetailsRequest, setTransactionDetailsRequest] =
    useState<RetrieveAllTransactionsRequest>();
  const [showTransactionSummary, setShowTransactionSummary] = useState(true);
  const [isChecked, setIsChecked] = useState<number[]>([]);
  const [checkedAll, setCheckedAll] = useState<boolean>(false);

  const filterSelectData = useForm<AdminTransactionSelectData>({
    initialValues: {
      partnersData: [],
      resellersData: [],
      merchantsData: [],
      merchantBranchesData: [],
      posData: [],
      transactionStatusData: [],
    },
  });

  const transactionFilterForm = useForm<TransactionFilterForm>({
    initialValues: {
      dateRange: [null, null],
      industryMid: '',
      transactionStatus: '',
      partner: '',
      reseller: '',
      merchant: '',
      merchantBranch: '',
      pos: '',
    },
  });
  return (
    <>
      {showTransactionSummary ? (
        <>
          <Title order={2} my='lg'>
            Transactions
          </Title>
          <div className='admin-transactions'>
            <Paper
              withBorder
              radius='md'
              shadow='lg'
              style={{
                flex: 1,
                height: '100%',
                padding: '20px 0',
                overflow: 'auto',
              }}
            >
              <MerchantBranchTransactionFilter
                form={transactionFilterForm}
                setData={setData}
                setPaginationData={setPaginationData}
                page={page}
                setPage={setPage}
                filterSelectData={filterSelectData}
                setIsLoadBranches={setIsLoadBranches}
                isLoadBranches={isLoadBranches}
                setTransactionSummaryRequest={setTransactionSummaryRequest}
                transactionSummaryRequest={transactionSummaryRequest}
                data={data}
                isChecked={isChecked}
                setTransactionDetails={setTransactionDetails}
                setDetailsPaginationData={setDetailsPaginationData}
                setTransactionDetailsRequest={setTransactionDetailsRequest}
                setShowTransactionSummary={setShowTransactionSummary}
                setTransactionStats={setTransactionStats}
              />
              <MerchantTransactionsTable
                transactionStats={transactionStats}
                data={data}
                paginationData={paginationData}
                setPage={setPage}
                page={page}
                setTransactionDetails={setTransactionDetails}
                setShowTransactionSummary={setShowTransactionSummary}
                setDetailsPaginationData={setDetailsPaginationData}
                setTransactionDetailsRequest={setTransactionDetailsRequest}
                setIsLoadBranches={setIsLoadBranches}
                transactionSummaryRequest={transactionSummaryRequest}
                isChecked={isChecked}
                setIsChecked={setIsChecked}
                checkedAll={checkedAll}
                setCheckedAll={setCheckedAll}
              />
            </Paper>
          </div>
        </>
      ) : (
        <MerchantTransactionsDetails
          transactionDetails={transactionDetails}
          detailsPaginationData={detailsPaginationData}
          transactionDetailsRequest={transactionDetailsRequest}
          setShowTransactionSummary={setShowTransactionSummary}
        />
      )}
    </>
  );
}

export default MerchantBranchTransactionsPage;
